import { Suspense } from "react";
import { useTranslation } from "react-i18next";

import { useListFriendsSuspense } from "@/api/bale";
import { Button } from "@/components/Button";
import { Card, CardSubtitleHeader, CardTextContent } from "@/components/Card";
import { Missing } from "@/components/Missing";
import { ProfileItem } from "@/components/ProfileItem";
import { TextLoading } from "@/components/TextLoading";

export function FriendsCard({ accountId, className }: { accountId: string; className?: string }) {
  const { t } = useTranslation();

  return (
    <Card className={className}>
      <CardSubtitleHeader>{t("friends")}</CardSubtitleHeader>
      <Suspense
        fallback={
          <CardTextContent className="flex flex-col gap-2">
            <TextLoading className="h-12 w-full" />
          </CardTextContent>
        }
      >
        <FriendsList accountId={accountId} />
      </Suspense>
    </Card>
  );
}

function FriendsList({ accountId }: { accountId: string }) {
  const { t } = useTranslation();
  const friends = useListFriendsSuspense(accountId, {
    query: { select: (data) => data.data.friends },
  });
  return (
    <CardTextContent className="flex flex-col gap-2">
      {friends.data.slice(0, 8).map(({ profile }) => (
        <div className="flex flex-row items-center gap-4" key={profile.id}>
          <ProfileItem profile={profile} />
        </div>
      ))}
      {friends.data.length === 0 && <Missing>{t("they-have-no-friends")}</Missing>}
      {friends.data.length > 8 && <Button type="button">{t("see-all")}</Button>}
    </CardTextContent>
  );
}
